// extracted by mini-css-extract-plugin
export var brand = "_2o-9";
export var compact = "_2o-6";
export var extraSmall = "_2o-7";
export var icon = "_2o-0";
export var large = "_2o-4";
export var light = "_2o-1";
export var medium = "_2o-5";
export var outline = "_2o-b";
export var primaryDark = "_2o-a";
export var primaryLight = "_2o-8";
export var primaryModern = "_2o-c";
export var success = "_2o-2";
export var successSolid = "_2o-3";